"use client";

import CssBaseline from "@mui/material/CssBaseline";
import {
  ThemeProvider,
  createTheme,
  type ThemeOptions,
} from "@mui/material/styles";
import * as React from "react";

/** Always light — ignores OS / browser dark theme so text stays dark on our light UI. */
const lightThemeOptions: ThemeOptions = {
  palette: {
    mode: "light",
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        /* CssBaseline defaults body to paper white; keep app gradient from globals */
        body: {
          backgroundColor: "#f7fcf8",
          background:
            "linear-gradient(180deg, #f7fcf8 0%, #ffffff 100%)",
        },
      },
    },
  },
};

const lightTheme = createTheme(lightThemeOptions);

export function MuiLightThemeProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <ThemeProvider theme={lightTheme}>
      <CssBaseline enableColorScheme />
      {children}
    </ThemeProvider>
  );
}
